import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-config',
  templateUrl: './customer-config.component.html',
  styleUrls: ['./customer-config.component.scss']
})
export class CustomerConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
